var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ToastMessage bg-primary text-center p-e24"},[_c('h5',{staticClass:"uppercase text-white font-bold"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }